import React, { Fragment, useEffect, useMemo, useState } from "react";
import PageHeader from "../../common/components/PageHeader";
import { Box, Grid } from "@mui/material";
import DynamicCalendar from "./DynamicCalendar";
import { useDispatch, useSelector } from "react-redux";
import { showNotification } from "../../common/components/Notification/ToastifyNotification";
import { setLoading } from "../../features/authSlice";
import LoadingSpinner from "../../common/components/LoadingSpinner";
import { getAllSession } from "../../api/calendarApi";

const getWeekDates = (date) => {
    const currentDate = new Date(date);
    const day = currentDate.getDay();
    const diff = currentDate.getDate() - day + (day === 0 ? -6 : 1); // Monday start

    const weekDates = [];
    for (let i = 0; i < 7; i++) {
        const weekDate = new Date(currentDate);
        weekDate.setDate(diff + i);
        weekDates.push({
            date: new Date(weekDate),
            day: weekDate.getDate(),
            month: weekDate.getMonth(),
            year: weekDate.getFullYear(),
            dayName: weekDate.toLocaleDateString('en-US', { weekday: 'long' }),
            fullDayName: weekDate.toLocaleDateString('en-US', { weekday: 'long' }),
            isToday: weekDate.toDateString() === new Date().toDateString()
        });
    }
    return weekDates;
};

const MentorCalendar = () => {
    const dispatch = useDispatch();
    const { user, loading } = useSelector((state) => state.auth);
    const [events, setEvents] = useState([]);
    const today = new Date();
    const [currentDate, setCurrentDate] = useState(today);
    const [viewType, setViewType] = useState('month');
    const [selectedDate, setSelectedDate] = useState(today);
    const [service, setService] = useState(null);

    const weekDates = useMemo(() => getWeekDates(currentDate), [currentDate]);

    const getAllEvents = async () => {
        try {
            dispatch(setLoading({
                loading: true
            }));
            let response;

            if (viewType === 'month') {
                response = await getAllSession(currentDate.getMonth() + 1, currentDate.getFullYear(), null, null, service, user?.mentor?.mentor_profile_id);
            } else if (viewType === 'day') {
                response = await getAllSession(null, null, currentDate, currentDate, service, user?.mentor?.mentor_profile_id);
            } else if (viewType === 'week') {
                response = await getAllSession(null, null, weekDates[0].date, weekDates[6].date, service, user?.mentor?.mentor_profile_id);
            }
            setEvents(response.data.filter((a) => a.service_name !== null));
            dispatch(setLoading({
                loading: false
            }));
        } catch (err) {
            const errorMessage = err.response?.data?.errors?.[0]?.message || err.response?.data?.message || err?.response?.data?.error;
            showNotification(errorMessage, 'error');
            dispatch(setLoading({
                loading: false
            }));
        }
    }

    useEffect(() => {
        if (user?.user_id && currentDate) {
            getAllEvents();
        }
    }, [user?.user_id, currentDate, viewType, service])

    return (
        <Fragment>
            {loading && (
                <LoadingSpinner />
            )}
            <Box
                sx={{
                    height: '85vh',
                    overflow: 'auto'
                }}
            >
                <PageHeader
                    title="Schedule & Calendar"
                />
                <Grid container spacing={2}>
                    <Grid item md={12}>
                        <DynamicCalendar
                            currentDate={currentDate}
                            setCurrentDate={setCurrentDate}
                            selectedDate={selectedDate}
                            setSelectedDate={setSelectedDate}
                            viewType={viewType}
                            setViewType={setViewType}
                            events={events}
                            weekDates={weekDates}
                            getAllEvents={getAllEvents}
                            service={service}
                            setService={setService}
                        />
                    </Grid>
                </Grid>
            </Box>
        </Fragment>
    )
}

export default MentorCalendar;